import {} from "@next-platform/packages-ts-types";
import { axiosClient, getBaseUrlVersioned } from "../../services/axiosClient";
import { API_VERSION } from "../types";
import { PageBlockTransportErrorCategory } from "./PageBlockTransportErrorCategory";
import readPageBlockContentResponse from "./readPageBlockContentResponse";
import readPageBlockTransportFailure from "./readPageBlockTransportFailure";
/**
 * Shared Web/Native client for one page block content request. Executes exactly
 * one HTTP request and never retries; retry policy belongs to the caller.
 */
export default async function fetchPageBlockContent({ applicationId, pageKey, blockKey, isNsfw, signal, }) {
    const searchParams = new URLSearchParams({ isNsfw: String(isNsfw) });
    const apiUrl = `${getBaseUrlVersioned(API_VERSION.V2)}/applications/${encodeURIComponent(applicationId)}/pages/${encodeURIComponent(pageKey)}/blocks/${encodeURIComponent(blockKey)}/content?${searchParams.toString()}`;
    try {
        const response = await axiosClient.get(apiUrl, { signal });
        const pageBlockContent = readPageBlockContentResponse(response.data);
        if (pageBlockContent === null) {
            return {
                status: "error",
                category: PageBlockTransportErrorCategory.UNEXPECTED,
                httpStatus: response.status,
            };
        }
        return { status: "success", response: pageBlockContent };
    }
    catch (requestError) {
        return readPageBlockTransportFailure(requestError);
    }
}
